export default {
  name: 'AddTag',
  props: {
    selectedFilter: {
      type: String,
      default: ''
    }
  },
  watch: {
    selectedFilter (value) {
      if (value !== '' && value !== null && value !== undefined) {
        this.selectedValue = value
      }
    }
  },
  data () {
    return {
      isDropdownActive: false,
      list: ['Article Info', 'Catalogue info', 'Information Portal', 'Source info'],
      subList: {
        0: ['Title', 'Subtitle', 'Description', 'Author', 'Publication', 'Publisher', 'Publication Date'],
        1: ['Keywords'],
        2: ['info'],
        3: ['Source']
      },
      selectedValue: '',
      destroyComponent: false
    }
  },
  methods: {
    changeDropdown (event) {
      this.isDropdownActive = event
    },
    selectSubFilter (subFilter) {
      this.selectedValue = subFilter
    },
    destroy (command) {
      if (command === 'REMOVE') {
        this.destroyComponent = true
        // this.$destroy(true)
      }
    }
  }
}
